import { SendOtpBody, SendOtpResponse } from "../types/user";
import ApiService from "./ApiService";

class UserApi extends ApiService {
  constructor() {
    super(
      `${process.env.BACKEND_HOST_URL}/api` || "https://api.turftown.in/api"
    );
  }

  async sendOtp(
    body?: SendOtpBody,
    useCache?: boolean
  ): Promise<SendOtpResponse> {
    return this.post("v2/user/send_web_otp", body, false, useCache, true);
  }

  async getAppConfig(useCache?: boolean): Promise<SendOtpResponse> {
    return this.post("v2/user/app_config", {}, true, useCache, true);
  }
}

export const userApi = new UserApi();
